import { makeStyles } from '@material-ui/core/styles';

export const useDrawerStyles = makeStyles(theme => ({
  drawerLarge: {
    width: '85vw',
    maxWidth: 1600,
    [theme.breakpoints.only('md')]: {
      width: '90vw'
    },
    [theme.breakpoints.only('sm')]: {
      width: '92vw'
    },
    [theme.breakpoints.only('xs')]: {
      width: '95vw'
    }
  },
  dualContainers: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    minHeight: 0,
    position: 'relative',
    width: '100%'
  },
  historyListContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: 280,
    maxWidth: 350,
    height: '100%',
    overflow: 'auto',
    backgroundColor: theme.palette.grey[200]
  },
  conversationPanel: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden'
  },
  styledAlert: {
    borderRadius: 0,
    flexShrink: 0,
    position: 'sticky',
    left: 0,
    top: 0,
    zIndex: 1
  }
}));
